import React from 'react';
import styled from 'styled-components';
import { useWorkViewStore } from '../../shared/store/WorkViewStore';
import { getWorksMessage } from '../../shared/constants/pageMessages';
import RelatedProject from './RelatedProject';  
import { useEditMode } from '../../shared/hooks/useEditMode';

const RelatedProjectList: React.FC = () => {
  const activeWork = useWorkViewStore((s) => s.activeWork);
  const activeRelatedProjectList = useWorkViewStore((s) => s.activeRelatedProjectList);
  const { isEditMode } = useEditMode();

  if (activeWork === null) {
    return null;
  }

  return (
    <>
      {!isEditMode && activeRelatedProjectList.length > 0 &&
        <>
          <RelatedProjectTitle>{getWorksMessage('RELATED_PROJECT')}</RelatedProjectTitle>
          <RelatedProjectContainer>
            {activeRelatedProjectList.map((rp, index) => (
              <RelatedProject key={rp.id} index={index + 1} data={rp} />
            ))}
          </RelatedProjectContainer>
        </>
      }
    </>
  );
}

const RelatedProjectTitle = styled.h3`
  width: 100%;
  display: flex;
  align-items: center;

  margin-bottom: 10px;
  color: ${({ theme }) => theme.colors.color_Gray_03};
  ${({ theme }) => theme.typography.Body_03_1};
`;

const RelatedProjectContainer = styled.div`
  position: relative;
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
`;


export default RelatedProjectList;